export default __webpack_public_path__ + "app/module/eficiencia-fiscal/view/configuracao/icms/desvios-st/tabs/farmaceutico/tabela-abc-farma/index.html";